<template>
<div>
<v-container>
  <v-expansion-panels v-model="panel">
  <v-expansion-panel>
    <v-expansion-panel-header>Keresés</v-expansion-panel-header>
    <v-expansion-panel-content>
  <v-row  justify="end">
    <v-radio-group v-model="picked" row>
      <v-radio label="Aktív" color="#FF9800" value="false"></v-radio>
      <v-radio label="Archív" color="#FF9800" value="true" ></v-radio>
      <v-radio label="Mind" color="#FF9800" value="true, false" ></v-radio>
    </v-radio-group>
  </v-row>
  <v-row  justify="end">
    <v-radio-group v-model="student_type" row>
      <v-radio label="Tanuló" color="#FF9800" value="student"></v-radio>
      <v-radio label="Érdeklődő" color="#FF9800" value="inquirer" ></v-radio>
    </v-radio-group>
  </v-row>

  <v-row>
    <v-text-field
      v-model="search"
      @keyup.enter="Diakok_show = true, DiakokDetails_show = false, searching = true"
      label="Tanuló keresése"
      outlined
      clearable
      prepend-inner-icon="search"
    ></v-text-field>
  </v-row>
</v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
</v-container>

<Diakok v-show="Diakok_show"></Diakok>

<DiakokDetails v-show="DiakokDetails_show"></DiakokDetails>

<v-tooltip bottom>
  <template v-slot:activator="{ on }">
    <v-btn
      v-on="on"
      v-show="Diakok_show"
      @click="CreateStudent"
      fixed
      dark
      fab
      bottom
      left
      color="white"
    >
    <img src="https://www.gstatic.com/images/icons/material/colored_icons/1x/create_32dp.png">
    </v-btn>
  </template>
  <span>Új tanuló rogzítése</span>
</v-tooltip>

<v-btn
  v-show="DiakokDetails_show"
  @click="BackStudent"
  fixed
  dark
  fab
  bottom
  right
  color="red"
>
<v-icon>undo</v-icon>
</v-btn>

</div>
</template>

<script>
import DiakokDetails from '../components/diakok_details.vue'
import Diakok from '../components/diakok.vue'
import store from '../store'
import { mapFields } from 'vuex-map-fields'

export default {
  components: {
    Diakok,
    DiakokDetails
  },
  data () {
    return {
      panel: 0
    }
  },
  methods: {
    BackStudent: function () {
      this.DiakokDetails_show = false,
      this.Diakok_show = true
      this.customer_id = null
      this.contract_id = null
      this.student_exam_result = null
    },
    CreateStudent: function () {
      this.customer_id = null
      this.contract_id = null
      this.contract_type = null
      this.diakok_tab = 0
      this.archived = false
      this.DiakokDetails_show = true
      this.Diakok_show = false
    },
  },
  mounted () {

  },
  updated () {

  },
  created() {

  },
  computed: {
  ...mapFields([
    'showing.DiakokDetails_show',
    'showing.Diakok_show',
    'diakok_details.customer_id',
    'diakok_details.contract_id',
    'diakok_details.contract_type',
    'diakok_details.archived',
    'diakok_details.search',
    'diakok_details.searching',
    'diakok_details.picked',
    'diakok_details.student_type',
    'diakok_details.diakok_tab',
    'exam_details.student_exam_result'
]),
},

}

</script>

<style>
</style>
